import { getIdToken } from "@/lib/platform/firebase";

export const BILLING_API_BASE = "https://nohaya-billing-26730182444.us-central1.run.app";

export class BillingError extends Error {}

async function authedPost(path: string, body?: Record<string, unknown>): Promise<Record<string, unknown>> {
  const token = await getIdToken();
  const res = await fetch(`${BILLING_API_BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new BillingError(typeof data.detail === "string" ? data.detail : `Request failed (${res.status})`);
  return data;
}

export async function createRazorpaySubscription(): Promise<{ subscription_id: string; key_id: string }> {
  return authedPost("/billing/razorpay/create-subscription") as Promise<{ subscription_id: string; key_id: string }>;
}

export async function createPaypalSubscription(): Promise<{ subscription_id: string; approve_url: string | null }> {
  return authedPost("/billing/paypal/create-subscription") as Promise<{ subscription_id: string; approve_url: string | null }>;
}

export async function createResumeOrderRazorpay(sourceKey: string, jobTitle: string): Promise<{ order_id: string; key_id: string; amount: number }> {
  return authedPost("/billing/razorpay/create-order", { sourceKey, jobTitle }) as Promise<{ order_id: string; key_id: string; amount: number }>;
}

export async function createResumeOrderPaypal(sourceKey: string, jobTitle: string): Promise<{ order_id: string; approve_url: string | null }> {
  // returnPath sends the user back to this exact page (seed/id intact)
  // instead of a generic fixed redirect target — PayPal itself appends
  // `?token=<order_id>` to whatever return_url we configure on its side.
  const returnPath = window.location.pathname + window.location.search;
  return authedPost("/billing/paypal/create-order", { sourceKey, jobTitle, returnPath }) as Promise<{
    order_id: string;
    approve_url: string | null;
  }>;
}

export async function capturePaypalOrder(orderId: string): Promise<{ success: boolean }> {
  return authedPost("/billing/paypal/capture-order", { orderId }) as Promise<{ success: boolean }>;
}

// Records what was downloaded and when — kept separately from the purchase
// record itself, since one purchase unlocks unlimited re-downloads and each
// one needs its own timestamp/content snapshot for refund/dispute handling.
export async function logResumeDownload(sourceKey: string, jobTitle: string, resumeData: unknown): Promise<void> {
  await authedPost("/billing/resume/log-download", { sourceKey, jobTitle, resumeData: resumeData as Record<string, unknown> });
}
